export default "__VITE_ASSET__ALQPspp5__ 100w";